import { STORAGE_KEY_TRAITS } from '../constants';
import { getDecryptedValueBrowser } from '@rudderstack/analytics-js-cookies';
/**
 * Calculates age from a date of birth.
 * @returns number | null
 */
export function calculateAge(dob) {
    if (!dob)
        return null;
    const birthDate = new Date(dob);
    if (Number.isNaN(birthDate.getTime()))
        return null;
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}
/**
 * Checks if the given date of birth is under a restricted age threshold.
 * @param dob string or Date
 * @param threshold number (default 13)
 * @returns boolean
 */
export function isRestrictedAge(threshold = 13) {
    if (typeof window == 'undefined')
        return false;
    const encryptedTraits = sessionStorage.getItem(STORAGE_KEY_TRAITS);
    if (!encryptedTraits)
        return false;
    const decryptedTraits = getDecryptedValueBrowser(encryptedTraits);
    const age = calculateAge(decryptedTraits.date_of_birth);
    if (age === null)
        return false; // if unknown, treat as not restricted
    return age < threshold;
}
